import { createContext, useContext } from "react";
import SITE from "../content/site.json";

// Content is baked in at build time — no API, no database, no loading state.
// Edit src/content/site.json (via /admin or directly on GitHub) and the site rebuilds.
const ContentCtx = createContext({ content: SITE, loading: false, refresh: () => {} });

export const ContentProvider = ({ children }) => (
  <ContentCtx.Provider value={{ content: SITE, loading: false, refresh: () => {} }}>
    {children}
  </ContentCtx.Provider>
);

export const useContent = () => useContext(ContentCtx);
export default SITE;
